import { useEffect, useState } from "react";

type ChatBotRenderProps = {
  iframeUrl?: string;
  title?: string;
};

const DEFAULT_CHATBOT_URL = import.meta.env.VITE_APP_CHATBOT_URL_B2B;

export default function ChatBotRender({ title = "Chat Assistant" }: ChatBotRenderProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  const resolvedUrl = (DEFAULT_CHATBOT_URL || "").trim();

  useEffect(() => {
    setIsLoaded(false);
  }, [resolvedUrl]);

  if (!resolvedUrl) {
    return (
      <div className="grid h-full w-full place-items-center rounded-lg border border-theme-border bg-theme-surface-soft p-4 text-sm text-theme-text-muted">
        Chatbot URL is missing.
      </div>
    );
  }

  return (
    <div className="relative h-full w-full overflow-hidden rounded-lg ">
      {!isLoaded ? (
        <div className="absolute inset-0 grid place-items-center bg-[#050F21] text-theme-text-inverse">
          Loading chatbot...
        </div>
      ) : null}

      <iframe
        key={resolvedUrl}
        title={title}
        src={resolvedUrl}
        className="h-full w-full"
        loading="lazy"
        allow="clipboard-read; clipboard-write; microphone; camera"
        referrerPolicy="strict-origin-when-cross-origin"
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
}
